module.exports = ".ui-table table {\r\n    table-layout:inherit !important;\r\n}\r\n#options-menu\r\n{\r\n    border:1px solid #337ab7;color:#337ab7;\r\n}\r\n#options-menu a{\r\n    color:#337ab7;\r\n}\r\n.ui-dialog-footer .ui-widget-content \r\n{\r\n    border:none;\r\n    margin-top:50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-management/users-list/users-list.component.css
// module id = ./src/app/admin/user-management/users-list/users-list.component.css
// module chunks = main